export default __webpack_public_path__ + "static/media/027-sea urchin.756aed10.svg";